export default __webpack_public_path__ + "static/EBH_basti&kathi_glasl-8663757fea7e6de054d16bb71649bfdc.png";